import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { unregisterServiceWorkers } from './app/shared/utils/unregister-service-workers';

if (environment.production) {
  enableProdMode();
}

function bootstrap(): void {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

// Drop any lingering Angular SW + caches so clients pick up the new API URL bundle.
// The old SW still controls this load, so reload once we actually removed one
// instead of booting the app under the stale controller.
unregisterServiceWorkers(
  'serviceWorker' in navigator ? navigator.serviceWorker : undefined,
  'caches' in window ? caches : undefined,
)
  .then((removed) => {
    if (removed) {
      window.location.reload();
      return;
    }
    bootstrap();
  })
  .catch((err) => {
    console.error('SW invalidate failed', err);
    bootstrap();
  });
